/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-06-21 10:35:57.

import { Currency } from '../Types/BookitupDocument';

export interface BlockStyleDto extends KafkaDto {
  profileId: number;
  horizontalAlignment: HorizontalAlignment;
  fontColor: string;
  backgroundColor: string;
  borderColor: string;
  borderRadius: number;
  paddingTop: number;
  paddingBottom: number;
  paddingLeft: number;
  paddingRight: number;
  width: number;
}

export interface ContractDto extends KafkaDto {
  profileId: number;
  contactId: number;
  customerId: number;
  eventId: number;
  draft: boolean;
  subject: string;
  label: string;
  date: Date | null;
  number: string;
  aboveTextBlocks: TextBlockDto[];
  belowTextBlocks: TextBlockDto[];
  documentId: number | null;
  positions: PositionDto[];
  sum: number;
  subtotal: number;
  taxType: TaxType;
  summable: boolean;
  contractHead: ContractHead;
  contractFooter: ContractFooter;
  contractSign: ContractSign;
  customerSignType: CustomerSignType;
  fileName: string;
  creatable: boolean;
  frontCoverFileName: string;
  frontCoverPageCount: number;
  backCoverFileName: string;
  backCoverPageCount: number;
  digitalSignLink: string;
  discount: DiscountDto;
  taxSummary: TaxSummaryDTO;
  agreements: AgreementDTO[];
}

export interface ContractTemplateDto extends KafkaDto {
  profileId: number;
  name: string;
  standard: boolean;
  subject: string;
  positions: boolean | null;
  aboveTextBlocks: TextBlockDto[];
  belowTextBlocks: TextBlockDto[];
  frontCoverFileName: string;
  frontCoverPageCount: number;
  backCoverFileName: string;
  backCoverPageCount: number;
  contractHead: ContractHead;
  contractFooter: ContractFooter;
  contractSign: ContractSign;
  customerSignType: CustomerSignType;
  lastModified: Date;
  agreements: AgreementDTO[];
}

export interface CreateContractTemplateDto {
  name: string;
  subject: string;
  positions: boolean;
  aboveTextBlocks: CreateTextBlockDto[];
  belowTextBlocks: CreateTextBlockDto[];
  contractHead: ContractHead;
  contractFooter: ContractFooter;
  contractSign: ContractSign;
  customerSignType: CustomerSignType;
}

export interface CreateTextBlockDto {
  contentFirstColumn: string;
  headerFirstColumn: string;
  contentSecondColumn: string;
  headerSecondColumn: string;
}

export interface DiscountDto {
  value: number;
  type: DiscountType;
  description: string;
  amount: number;
}

export type Language = 'german' | 'english';

export interface BaseDocument extends KafkaDto {
  summable: boolean;
  subject: string;
  documentType: DocumentType;
  headRow: string;
  endRow: string;
  positions: PositionDto[];
  sum: number;
  subtotal: number;
  taxType: TaxType;
  taxSummary: TaxSummaryDTO;
  discount: DiscountDto;
  finalSum: number;
  finalNet: number;
  positionGroups: PositionGroupDTO[];
  // For patch purposes
  discountValue: number;
  discountType: DiscountType;
  discountDescription: string | null;
  currencySymbol: string;
  currency: Currency;
  language?: Language | null;
}

export interface DocumentDto extends BaseDocument {
  originDocumentId: number;
  profileId: number;
  contactId: number;
  customerId: number;
  eventId: number;
  draft: boolean;
  label: string;
  number: string;
  shippingType: ShippingType;
  shippingDate: Date;
  shippingEndDate: Date;
  date: Date;
  validUntil: Date;
  partialInvoices: PartialInvoiceDto[];
  fileName: string;
  digitalSignLink: string;
  dueDate: Date;
  locked: boolean;
  hasPayments: boolean;
  finalTaxSummary: TaxSummaryDTO;
  finalInvoiceCreatable: boolean;
  acceptedAt: Date;
  paid: boolean;
  daysTilExpire: number;
  accepted: boolean;
  finalDocument: number | null;
  xrechnungRequired: boolean;
  originalInvoiceNumber: string | null;
  hasReminders: boolean;
  epcQrPayment: string | null;
}

export interface DocumentTemplateDto extends BaseDocument {
  name: string;
  standard: boolean;
  freeKms: number | null;
  freeKmsThreshold: number | null;
}

export type PositionGroupDTO = {
  id: string;
  name: string;
};

export interface DocumentIdListDto {
  documentIds: number[];
}

export interface DocumentTemplateKafkaDto extends KafkaDto {
  profileId: number;
  documentType: DocumentType;
  name: string;
  standard: boolean;
  subject: string;
  headRow: string;
  endRow: string;
  positions: PositionDto[];
  summable: boolean;
}

export interface EventIdListDto {
  eventIds: number[];
}

export interface EventListDto {
  events: EventDto[];
}

export interface ExistingDto {
  entityId: number;
  entityType: string;
  fileName: string;
}

export interface IdListDto {
  ids: number[];
}

export interface PartialInvoiceDto extends KafkaDto {
  date: Date;
  documentNumber: string;
  label: string;
  gross: number;
  vat: number;
  net: number;
  taxRate: number;
}

export interface PositionDto extends KafkaDto {
  label: string;
  subtext: string;
  price: number;
  netPrice: number;
  priceUnit: number;
  netPriceUnit: number;
  tax: number;
  amount: string;
  unit: string;
  priceSubtext: string;
  optional: boolean;
  negotiable: boolean;
  min: number;
  max: number;
  profileId: number;
  discount: DiscountDto;
  groupId: string | null;
  factor: number | null;
  discountValue: number;
  discountType: DiscountType;
  isFirst: boolean;
  isLast: boolean;
  type: 'RESOURCE' | 'FREE_TEXT' | 'REGULAR';
  autoSelect: boolean;
  category: string | null;
  categoryId: string | null;
}

export interface TaxEntryDTO {
  amount: number;
  taxRatePercent: number;
  taxAmount: number;
}

export interface TaxSummaryDTO {
  taxEntries: TaxEntryDTO[];
}

export interface TextBlockDto extends KafkaDto {
  profileId: number;
  isAbove: boolean;
  contentFirstColumn: string | null;
  headerFirstColumn: string;
  imageEntityTypeFirstColumn: string | null;
  imageEntityIdFirstColumn: string | null;
  imageFileNameFirstColumn: string | null;
  styleFirstColumn: BlockStyleDto;
  styleSecondColumn: BlockStyleDto;
  contentSecondColumn: string | null;
  headerSecondColumn: string;
  imageEntityTypeSecondColumn: string | null;
  imageEntityIdSecondColumn: string | null;
  imageFileNameSecondColumn: string | null;
}

export interface KafkaDto extends Serializable {
  id: number;
  lastModified: Date;
}

export interface EventDto {
  id: number;
  sumOpen: number;
  sumConfirmed: number;
}

export interface Serializable {}

export type HorizontalAlignment = 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';

export const horizontalAlignmentToCssProp = (horizontalAlignment?: HorizontalAlignment) => {
  if (!horizontalAlignment) {
    return 'left';
  }
  if (horizontalAlignment === 'JUSTIFIED') {
    return 'justify';
  }
  return horizontalAlignment.toLocaleLowerCase();
};

export type TaxType =
  | 'net'
  | 'gross'
  | 'vatfree'
  | 'intraCommunitySupply'
  | 'constructionService13b'
  | 'externalService13b'
  | 'thirdPartyCountryService'
  | 'thirdPartyCountryDelivery';

export type ContractHead = 'NONE' | 'LETTERHEAD' | 'PARTIES';

export type ContractFooter = 'NONE' | 'CENTERED' | 'BLOCKS';

export type ContractSign = 'NONE' | 'BOTH' | 'CUSTOMER';

export type CustomerSignType = 'BASE64' | 'TEXT_FIELD' | 'IMAGE_UPLOAD';

export type DiscountType = 'PERCENT' | 'ABSOLUTE';

export type DocumentType =
  | 'OFFER'
  | 'CONFIRMATION'
  | 'CONTRACT'
  | 'DELIVERYNOTE'
  | 'INVOICE'
  | 'CREDIT_NOTE'
  | 'PARTIAL_INVOICE'
  | 'CANCEL'
  | 'REMINDER'
  | 'QUESTIONNAIRE';

export type ShippingType = 'service' | 'serviceperiod' | 'delivery' | 'deliveryperiod' | 'none';

export type AgreementDTO = {
  id: string;
  content: string;
  required: boolean;
  entityId: string | null;
  entityType: string | null;
  fileName: string | null;
};

export interface BaseDocumentContextProps<T extends BaseDocument> {
  bookitupDocument: T | null;
  loading: boolean;
  refresh: () => void;
  handleChange: (patch: Partial<T>) => void;
  savePatch: (patch: Partial<T>) => Promise<boolean>;
  groupHandlers: PositionGroupHandlers;
  positionHandlers: PositionHandlers;
}

export interface PositionHandlers {
  patchPosition: (positionId: number, patch: Partial<PositionDto>) => Promise<boolean>;
  movePosition: (positionId: number, targetPositionId: number) => Promise<boolean>;
  deletePosition: (positionId: number) => void;
  addPosition: (targetPositionId?: number, position?: PositionDto) => Promise<boolean>;
  addProducts: (productIds: number[], targetPositionId?: number) => Promise<boolean>;
  swapPositions: (direction: string, positionId: number) => void;
  openPositionModal: (position: PositionDto) => void;
  removePositionFromGroup: (positionId: number) => Promise<boolean>;
  insertPositionIntoGroup: (groupId: string, positionId: number, targetPositionId?: number) => Promise<boolean>;
}

export interface PositionGroupHandlers {
  addGroup: (index?: number) => Promise<boolean>;
  moveGroup: (from: number, to: number) => Promise<boolean>;
  insertNewPositionIntoGroup: (groupId: string, product?: PositionDto) => Promise<boolean>;
  removeGroup: (groupId: string, label: string) => void;
}

export interface PositionDragItem {
  position: PositionDto;
}

export interface PositionGroupDragItem {
  group: PositionGroupDTO;
  idx: number;
}

export const DragItem = {
  GROUP: 'documentGroup',
  POSITION: 'documentPosition',
};

export type SequentialNumber = {
  minimumLength: number;
};

export type ProductsFilter = {
  searchQuery: string;
  categories: string[];
};


export type CategoryDto = {
  id: string;
  name: string;
};
